import { createContext } from 'react';

const ConversationsContext = createContext();

export default ConversationsContext;
